import type { NextPage } from 'next';

import { Box, Heading, Stack } from '@chakra-ui/react';

import { Faqs } from '~/components/faq';
import { Logo } from '~/components/logo';
import { SectionCard } from '~/components/section-card';
import { Seo } from '~/components/seo';
import { SimplePageLayout } from '~/components/simple-page-layout';
import { useResetPasswordRedirect } from '~/hooks/use-reset-password-redirect';

const Support: NextPage = () => {
  useResetPasswordRedirect();

  return (
    <SimplePageLayout>
      <Seo title='Support for Joyline.io' />
      <Box textAlign='center' mb={16}>
        <Logo />
      </Box>
      <Stack as='main' spacing={8}>
        <SectionCard title={`We're happy to help`} titleCentered={true}>
          <Faqs />
        </SectionCard>

        <Stack as='section' p={{ base: 4, lg: 8 }} spacing={4} bgColor='white' borderRadius='xl'>
          <Heading as='h2' size='h4' textAlign='center'>
            Need more help? Contact us at
          </Heading>
          <Heading as='h2' size='h2' color='green' textAlign='center'>
            support@joyline.io
          </Heading>
        </Stack>
      </Stack>
    </SimplePageLayout>
  );
};

export default Support;
